import { render, staticRenderFns } from "./shop_list.vue?vue&type=template&id=702faa76&scoped=true&"
import script from "./shop_list.vue?vue&type=script&lang=js&"
export * from "./shop_list.vue?vue&type=script&lang=js&"
import style0 from "./shop_list.vue?vue&type=style&index=0&id=702faa76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702faa76",
  null
  
)

export default component.exports